import { render, staticRenderFns } from "./BindPhoneV2.vue?vue&type=template&id=465792a6"
import script from "./BindPhoneV2.vue?vue&type=script&lang=js"
export * from "./BindPhoneV2.vue?vue&type=script&lang=js"
import style0 from "./BindPhoneV2.vue?vue&type=style&index=0&id=465792a6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports